import { gql } from '@apollo/client';
import { SECTION_FRAGMENT } from '../fragments/section.newsletter.graphql';

export const UPDATE_SECTION_MUTATION = gql`
  mutation UpdateSection(
    $data: SectionUpdateInput!
    $where: SectionWhereUniqueInput!
  ) {
    updateSection(data: $data, where: $where) {
      ...Section
    }
  }
  ${SECTION_FRAGMENT}
`;
